import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { recoveryStatus } from 'state/modules/auth';
import { display } from 'state/modules/dialog';

/**
 * Dispatches recoveryStatus() (GET /owners/recovery/status) and surfaces a
 * failure via the standard error dialog, instead of leaving
 * state.auth.recoveryCodesRemaining silently unset. Shared by every call
 * site that needs this value but isn't already handling its own fetch
 * failure (App.js's global low-codes banner, VerificationRequired's
 * step-up screen) — previously duplicated inline in both.
 */
const useRecoveryStatusFetch = () => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  return useCallback(() => dispatch(recoveryStatus()).catch(err => {
    dispatch(display(formatMessage({ id: 'notifications.title.error' }), err.message, 'error'));
  }), [dispatch, formatMessage]);
};

export default useRecoveryStatusFetch;
